import React, { useEffect, useState } from 'react';
import i18next from 'i18next';
import clsx from 'clsx';

import { Tooltip } from 'primereact/tooltip';

// Zustand Stores
import useStatisticsStore from '../store/useStatisticsStore';
import useUserStore from "../store/useUserStore";
import useSelectedCompanyStore from "../store/useSelectedCompanyStore";

import axiosInstance from '../config/axiosConfig';
import DashboardDropdown from '../components/DashboardDropdown';

// Statistics Imports
import StatusCard from '../components/StatusCard';
import CandidatesTestsTable from '../components/CandidatesTestsTable'
import StackedBarChart from '../components/StackedBarChart';

// import RadarChart from '../components/RadarChart';
// import MostPlayedSmoothLines from '../components/MostPlayedSmoothLines';

const t = (i18nKey, params) => i18next.t(`userDashboard.home.${i18nKey}`, params);

const Home = () => {

    const dateFilters = [
        { label: t('30_days'), value: '30_days' },
        { label: t('7_days'), value: '7_days' },
        { label: t('24_hours'), value: '24_hours' },
        { label: t('allTime'), value: 'allTime' },
    ];

    const user = useUserStore((state) => state.user);
    const selectedCompany = useSelectedCompanyStore((state) => state.selectedCompany);

    const statisticsModuleData = useStatisticsStore((state) => state.getModuleData('StatisticsModule'));
    const setStatisticsModuleData = (data) => useStatisticsStore.getState().setModuleData('StatisticsModule', data);

    const candidatesModuleData = useStatisticsStore((state) => state.getModuleData('CandidatesModule'));
    const setCandidatesModuleData = (data) => useStatisticsStore.getState().setModuleData('CandidatesModule', data);

    const stackedBarChart = useStatisticsStore((state) => state.getModuleData('StackedBarChart'));
    const setStackedBarChart = (data) => useStatisticsStore.getState().setModuleData('StackedBarChart', data);

    const dateFilter = useStatisticsStore((state) => state.dateFilter);
    const setDateFilter = useStatisticsStore((state) => state.setDateFilter);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!selectedCompany) return;
        if (statisticsModuleData && statisticsModuleData?.dateFilter === dateFilter) return setIsLoading(false);

        axiosInstance.get(`/dashboard/companies/${selectedCompany.company_id}/statistics/${dateFilter}`).then(response => {

            const statisitcsModuleData = {
                campaign_count: response.data?.campaign_count || 0,
                candidates_sum: response.data?.candidates_sum || 0,
                dateFilter: dateFilter
            };

            setStatisticsModuleData(statisitcsModuleData);

            setCandidatesModuleData(response.data?.candidate_details);

            setStackedBarChart(response.data?.tests_count_per_day);

        }).catch(error => {
            console.log('error', error);
            setStatisticsModuleData({
                campaign_count: 0,
                candidates_sum: 0,
                dateFilter: dateFilter
            });
        }).finally(() => {
            setIsLoading(false);
        });
    }, [dateFilter]);

    const StatisticsModule = () => {
        return (
            <div className="partContainer">
                <div className="columns is-vcentered is-multiline">

                    <div className="column is-one-third has-text-centered p-2">
                        <div className="partTitle __title">{t('statistics')}</div>
                        <div className="partTitle">{t('since_date')} {new Date(new Date().setDate(new Date().getDate() - 30)).toLocaleDateString()}</div>
                    </div>

                    <div className="column statusCardsContainer">

                        <div className='flex1'>
                            <StatusCard
                                isLoading={!isLoading}
                                iconName="fa-solid fa-bullhorn"
                                iconClassNames={['has-text-dgrad-blue']}
                                name={t('campaigns')}
                                number={statisticsModuleData?.campaign_count || 0}
                                statusCardClassNames={['gradient-border-1']}
                                statusCardTextClassNames={['has-text-dgrad-blue']}
                                pathName={'/dashboard/campaigns'}
                            />
                        </div>

                        <div className='flex1'>
                            <StatusCard
                                isLoading={!isLoading}
                                iconName="fa-solid fa-users-line"
                                iconClassNames={['has-text-dgrad-deepsy']}
                                name={t('candidates')}
                                number={statisticsModuleData?.candidates_sum || 0}
                                statusCardClassNames={['gradient-border-2']}
                                statusCardTextClassNames={['has-text-dgrad-deepsy']}
                                pathName={'/dashboard/campaigns'}
                            />
                        </div>

                    </div>

                </div>
            </div>
        )
    }

    const CandidatesModule = () => {
        return (
            <div className="partContainer">
                <div className="columns is-vcentered is-multiline">

                    <div className="titleAndButtons">

                        <h1 className="partMainTitle is-size-3">{t('candidates_statistics')}</h1>

                        {/* <div className="buttonsContainer">
                        TODO: Pagination buttons
                        </div> */}

                    </div>

                    <CandidatesTestsTable data={candidatesModuleData} isLoading={isLoading} />

                </div>
            </div>
        )
    };

    const ChartModule = () => {
        const [testsSent, setTestsSent] = useState(false);

        if (!stackedBarChart || stackedBarChart?.length < 5) return null;

        return (
            <div className="partContainer">

                <div className="titleAndButtons">

                    <h1 className="partMainTitle">{t('tests_statistics')}</h1>

                    <div className="buttonsContainer">

                        <button
                            className={clsx('button', { 'is-active': !testsSent })}
                        // onClick={() => { setTestsSent(!testsSent) }}
                        >{t('tests_done')}</button>

                        <button
                            className={clsx('button', { 'is-active': testsSent })}
                            // onClick={() => { setTestsSent(!testsSent) }}
                            disabled={true}
                        >{t('tests_sent')}</button>

                    </div>

                </div>

                <div className="titleBorder"></div>

                {!testsSent && <StackedBarChart testCountData={stackedBarChart} />}
                {testsSent && <StackedBarChart testCountData={stackedBarChart} />}
            </div>
        )
    }

    // const TopPlacementModule = () => {
    //     const items = ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6', 'Item 7'];
    //     const colors = ['#FFC107', '#4CAF50', '#2196F3', '#FF5722', '#9C27B0', '#00BCD4', '#795548'];

    //     return (
    //         <div className="partContainer">

    //             <div className="titleAndButtons">

    //                 <h1 className="partMainTitle">Top Placements</h1>

    //             </div>

    //             <div className="topPlacementsChart columns is-vcentered is-multiline">

    //                 <div className="radar-chart column is-6">
    //                     <div className="topPlacementsChart__title">Scores moyens à chaque test</div>

    //                     <div className="columns is-multiline is-mobile">

    //                         {items.map((item, index) => (
    //                             <div key={index} className="column is-one-quarter">

    //                                 <div className='coloredItem' style={{ position: 'relative' }}>

    //                                     <div style={{
    //                                         position: 'absolute',
    //                                         left: 0,
    //                                         top: '50%',
    //                                         transform: 'translateY(-50%)',
    //                                         width: '15px',
    //                                         height: '15px',
    //                                         borderRadius: '50%',
    //                                         backgroundColor: colors[index] || 'black',

    //                                     }}></div>

    //                                     <p style={{ marginLeft: '20px' }}>
    //                                         {item}
    //                                     </p>

    //                                 </div>

    //                             </div>
    //                         ))}
    //                     </div>

    //                     <RadarChart timePeriod={dateFilter} />
    //                 </div>

    //                 <div className="radar-chart column is-6" style={{ opacity: 0 }}>
    //                     <div className="topPlacementsChart__title">participants ayant completé le test</div>
    //                     <RadarChart />
    //                 </div>

    //             </div>

    //         </div>
    //     )
    // }

    // const MostPlayedModule = () => {

    //     return (
    //         <div className="partContainer">

    //             <div className="titleAndButtons">

    //                 <h1 className="partMainTitle">Tests les plus joués</h1>

    //             </div>

    //             <div className="MostPlayedSmoothLines columns is-vcentered is-multiline">

    //                 <MostPlayedSmoothLines />

    //             </div>

    //         </div>

    //     )
    // }

    return (
        <section className='home'>
            <div className="container">
                {/* Welcome message */}
                <div className="columns is-vcentered">

                    <div className="column">

                        <div className="header-content">
                            <p className="welcomeUser mb-0">{t('welcome', { userName: user.first_name || '' })}</p>
                            <h1 className="linear-deepsy-text is-2 mt-0">{t('my_dashboard')}</h1>
                        </div>

                    </div>

                    <div className="column">

                        <div className="dashboard-controls">

                            {/* <DashboardDropdown
                                Data={dateFilters}
                                data={dateFilters.find(filter => filter.value === dateFilter)}
                                setData={(e) => { e.value !== dateFilter ? (setDateFilter(e.value), setIsLoading(true)) : null }}
                            />

                            <hr className="vertical-hr" /> */}

                            <div className="buttons">

                                <button className="button is-outlined" disabled>
                                    <span className="icon pl-1">
                                        <i className="fa-solid fa-download"></i>
                                    </span>
                                    <span>{t('download')}</span>
                                </button>

                                <button className="button is-outlined" disabled>
                                    <span className="icon pl-1">
                                        <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                    </span>
                                    <span>{t('share')}</span>
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

                {/* Statistics */}
                <StatisticsModule />

                {/* Candidate */}
                <CandidatesModule />

                {/* Chart */}
                <ChartModule />

                {/* Top Placement */}
                {/* <TopPlacementModule /> */}

                {/* Most played */}
                {/* <MostPlayedModule /> */}

            </div>
        </section>
    );
};

export default Home;